import { runAiJob } from './aiJobs';

export type AiAction = 'improve-text' | 'generate-text' | 'outline' | 'improve-prompt';

export interface AiResult {
  original: string;
  result: string;
}

export async function runAi(action: AiAction, text: string, instruction?: string): Promise<AiResult> {
  const result = await runAiJob(`/api/ai/${action}`, { text, instruction }, (poll) => poll.result ?? '');
  return { original: text.trim(), result };
}
